module.exports = __webpack_public_path__ + "img/flot8.1905ec13.svg";